module.exports = __webpack_public_path__ + "img/42_40.680fb0c9.png";